import {RemoteGetPatientData} from 'data/usecases/private/my-hospitalization/remote-get-patient-data';
import {GetPatientData} from 'domain/usecases/private/my-hospitalization/get-patient-data';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {MyHospitalizationEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetPatientData = (): GetPatientData =>
	new RemoteGetPatientData(
		makeBFFApiUrl(MyHospitalizationEndpoints.patientData),
		makeAuthorizeHttpClientDecorator(),
	);
